export function isNullOrUndefined(value: any) {
    return value === null || value === undefined;
}

export function isNotNullAndUndefined(value: any) {
    return value !== null && value !== undefined;
}

export function isStringEmpty(str : string) {
    return (!str || str.length === 0 );
}